import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowForward } from '@mui/icons-material';
import portadaImage from '../assets/portada-ib.jpg';

/**
 * Home - Landing/Welcome Page
 * 
 * Full-screen hero image with system title overlay and entry button
 * Displays Interbarge brand image with system identification
 */
const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={portadaImage}
        alt="Interbarge Fleet"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />

      {/* Title Overlay - On Blue Band */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '15%',
          left: 60,
          zIndex: 1,
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: 'white',
            fontWeight: 700,
            textShadow: '2px 2px 8px rgba(0, 0, 0, 0.5)',
            letterSpacing: '1px',
            fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3rem' },
          }}
        >
          INTERBARGE SUPPLIER MANAGEMENT
        </Typography>
      </Box>

      {/* Button Overlay - Bottom */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 40,
          left: 60,
          zIndex: 1,
        }}
      >
        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowForward />}
          onClick={() => navigate('/dashboard')}
          sx={{
            backgroundColor: '#b32317', // Rojo Interbarge
            color: 'white',
            fontWeight: 700,
            fontSize: '1.1rem',
            padding: '14px 40px',
            borderRadius: 2,
            textTransform: 'none',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
            border: '2px solid white',
            '&:hover': {
              backgroundColor: '#002d62', // Azul Interbarge
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.5)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          INGRESAR AL SISTEMA
        </Button>
      </Box>
    </Box>
  );
};

export default Home;
